import React, { useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useNavigate } from 'react-router-dom';
import { apiFetch } from './api';

function Login() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMessage('');

    if (!username || !password) {
      setErrorMessage('Username e password sono obbligatori!');
      return;
    }

    setIsSubmitting(true);
    try {
      const response = await apiFetch('/api/Auth/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, password })
      });
      const data = await response.json();
      if (!response.ok || !data.token) {
        setErrorMessage(data.message || 'Errore di autenticazione');
      } else {
        localStorage.setItem('token', data.token);
        navigate('/dashboard');
      }
    } catch (err) {
      setErrorMessage('Errore di rete o server non raggiungibile');
    }
    setIsSubmitting(false);
  };

  return (
    <div className="row justify-content-center mt-5">
      <div className="col-md-6 col-lg-4">
        <div className="email-form">
          <div className="text-center mb-4">
            <h2 className="text-primary">Accesso al Sistema</h2>
            <p className="text-muted">Sistema di Invio Email ANUTEL ETS</p>
          </div>

          {errorMessage && (
            <div className="alert alert-danger" role="alert">
              <i className="fas fa-exclamation-circle"></i> {errorMessage}
            </div>
          )}

          <form method="post" id="loginForm" onSubmit={handleSubmit} autoComplete="off">
            <div className="mb-3">
              <label htmlFor="Username" className="form-label">
                <i className="fas fa-user"></i> Nome Utente
              </label>
              <input type="text" className="form-control" name="Username" id="Username"
                value={username} onChange={e => setUsername(e.target.value)}
                placeholder="Inserisci username" autoFocus disabled={isSubmitting} />
            </div>
            <div className="mb-3">
              <label htmlFor="Password" className="form-label">
                <i className="fas fa-lock"></i> Password
              </label>
              <input type="password" className="form-control" name="Password" id="Password"
                value={password} onChange={e => setPassword(e.target.value)}
                placeholder="Inserisci password" disabled={isSubmitting} />
            </div>
            <div className="d-grid gap-2">
              <button type="submit" className="btn btn-primary btn-lg" id="loginButton" disabled={isSubmitting}>
                {isSubmitting ? <><i className="fas fa-spinner fa-spin"></i> Accesso...</> : <><i className="fas fa-sign-in-alt"></i> Accedi</>}
              </button>
            </div>
          </form>

          <div className="text-center mt-3">
            <small className="text-muted">
              Accesso riservato al personale autorizzato
            </small>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;
